// src/utils/weldLocations.js
// Shared helpers for Weld County voting location data — used by the
// Where to Vote map (WhereToVote.js) and the nearest-locations lookup
// (VoterLookup.js) so both stay in sync with the same JSON source.

const WELD_LOCATIONS_URL = '/geojson/weld/weld_voting_locations.json';

export const fetchWeldVotingLocations = async () => {
  const response = await fetch(WELD_LOCATIONS_URL);
  if (!response.ok) {
    throw new Error(`Failed to load Weld voting locations: ${response.status}`);
  }
  const data = await response.json();
  return data.locations || [];
};

export const isVspcType = (type) => type === 'VSPC';
export const isDropOffType = (type) => type === 'Drop-Off' || type === '24hr Drop-Off';

const EARTH_RADIUS_MILES = 3958.8;

// Great-circle distance between two lat/lng points, in miles.
export const haversineMiles = (lat1, lng1, lat2, lng2) => {
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_MILES * c;
};

// Returns the `count` closest locations to (lat, lng), each annotated with `distance` (miles).
export const nearestLocations = (locations, lat, lng, count = 3) => {
  return locations
    .map((loc) => ({ ...loc, distance: haversineMiles(lat, lng, loc.lat, loc.lng) }))
    .sort((a, b) => a.distance - b.distance)
    .slice(0, count);
};
